import { CommandingViewMode } from 'owa-outlook-service-option-store/lib/store/schema/options/CommandingOptions';
import { createStore } from 'satcheljs';
import type CommandRibbonStore from './schema/CommandRibbonStore';

// NOTE: if we choose to make shyRibbon default ON,
// we should set the default to isFeatureEnabled('mon-ribbon-shymode')
const defaultCommandRibbonStore = <CommandRibbonStore>{
    viewMode: CommandingViewMode.CommandBar,
    ribbonOWAMSITExperimentToolbarUser: false,
    shyRibbon: false,
};

const store = createStore<CommandRibbonStore>('CommandRibbon', defaultCommandRibbonStore)();
export default store;
export const getStore = () => store;
